import React, { useState } from 'react';
import { EaseDrawer } from '../../../libs/EaseDrawer';
import { Descriptions, Badge, Typography, Popconfirm, Button } from 'antd';
import { PAYOUT_LINK_STATUS_TYPES, BENEFICIARY_TYPE_MASTER } from '../../../constants';
import { Text4 } from '../../../styles';
import { printRupee } from '../../../app_methods';
import { PaymentAttemptsDrawer } from './attempts';
import { PermissionHoc } from '../../HOC';
import moment from 'moment';
import './index.scss';


const DeactivatePermissableButton = PermissionHoc(Button, "PAYOUT_LINKS_WRITE", { is_component: true, fallbackComponent: null });

const PayoutLinkDetails = (props) => {
    const payoutLink = props.payoutLink || {};
    const [showAttemptsDrawer, setShowAttemptsDrawer] = useState(false);

    const toggleAttemptsDrawer = () => {
        setShowAttemptsDrawer(!showAttemptsDrawer);
    };
    return (
        <EaseDrawer
            className="payout-link-details-drawer"
            visible={props.visible}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={525}
        >
            <Typography.Title className="mt-4" level={4}>Payout Link Details</Typography.Title>
            <div className="w-100 d-flex justify-content-end">
                <Button onClick={toggleAttemptsDrawer}>Payment Attempts</Button>
            </div>
            <Descriptions className="mt-4" title={false} column={1} bordered size="small">
                <Descriptions.Item label="Payee Name">{payoutLink.payee_name}</Descriptions.Item>
                <Descriptions.Item label="Payee Email ID">{payoutLink.payee_email || "---"}</Descriptions.Item>
                <Descriptions.Item label="Payee Phone">{payoutLink.payee_phone || "---"}</Descriptions.Item>
                <Descriptions.Item label="Link"><a href={payoutLink.link} target="_blank">{payoutLink.link}</a></Descriptions.Item>
                <Descriptions.Item label="Amount">{printRupee(payoutLink.amount)}</Descriptions.Item>
                <Descriptions.Item label="Unique Name">{payoutLink.unique_code}</Descriptions.Item>
                <Descriptions.Item label="Description">{payoutLink.description || "---"}</Descriptions.Item>
                {
                    payoutLink.expiry_date ?
                        <Descriptions.Item label="Expiry Date">
                            {payoutLink.expiry_date && moment(payoutLink.expiry_date).format("LL")}
                        </Descriptions.Item> : null
                }
                {
                    payoutLink.status ?
                        <Descriptions.Item label="Status">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                                <Badge
                                    color={PAYOUT_LINK_STATUS_TYPES[payoutLink.status].color}
                                    text={<Text4>{PAYOUT_LINK_STATUS_TYPES[payoutLink.status].label}</Text4>}
                                />
                                {
                                    // payoutLink.status == "active" && !payoutLink.is_submerchant ?
                                    payoutLink.status == "active" ?
                                        <Popconfirm title="Are you sure you want to deactivate this link?" okText="Yes" cancelText="No" onConfirm={() => props.deactivateLink(payoutLink)}>
                                            <DeactivatePermissableButton size="small" type="danger" ghost loading={props.isDeactivating}>Deactivate</DeactivatePermissableButton>
                                        </Popconfirm> : null
                                }
                            </div>
                        </Descriptions.Item>
                        :
                        null
                }
                {
                    payoutLink.status == "deactivated" ?
                        <Descriptions.Item label="Deactivation Reason">{payoutLink.deactivation_reason || "---"}</Descriptions.Item> : null
                }
                {/* <Descriptions.Item label="Skip Authentication">{payoutLink.skip_authentication ? "Yes" : "No"}</Descriptions.Item>
                {
                    !payoutLink.skip_authentication ? 
                        <Descriptions.Item label="Authentication Key"><Text4 copyable>{payoutLink.authentication_key}</Text4></Descriptions.Item>
                        :
                        null
                } */}
                <Descriptions.Item label="Allowed Beneficiary Types">{payoutLink.allowed_beneficiary_types && payoutLink.allowed_beneficiary_types.map(b => BENEFICIARY_TYPE_MASTER.find(o => o.key == b).label).join(", ")}</Descriptions.Item>
                <Descriptions.Item label="Created At">{payoutLink.created_at && moment(payoutLink.created_at).format("LL")}</Descriptions.Item>
            </Descriptions>

            <PaymentAttemptsDrawer
                visible={showAttemptsDrawer}
                onClose={toggleAttemptsDrawer}
                payoutLink={payoutLink}
            />

        </EaseDrawer>
    )
};

export { PayoutLinkDetails };